import {Skeleton, Stack} from '@mui/material'
import React from 'react'

export const PageSkeleton: React.FC = () => (
  <Stack spacing={2} sx={{p: 3}}>
    <Skeleton variant="rectangular" height={40} />
    <Skeleton variant="rectangular" height={300} />
    <Skeleton variant="rectangular" height={200} />
  </Stack>
)
